"use client";

import React, { createContext, useContext, ReactNode, useState } from "react";

interface TemplateDetailContextType {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
  slug: string | null;
  setSlug: React.Dispatch<React.SetStateAction<string | null>>;
  useCase: string | null;
  setUseCase: React.Dispatch<React.SetStateAction<string | null>>;
  primaryProduct: string | null;
  setPrimaryProduct: React.Dispatch<React.SetStateAction<string | null>>;
}

// Create the context with default values
const TemplateDetailContext = createContext<TemplateDetailContextType>({
  setIsOpen: () => {},
  isOpen: false,
  slug: null,
  setSlug: () => {},
  useCase: null,
  setUseCase: () => {},
  primaryProduct: null,
  setPrimaryProduct: () => {},
});

// Create a provider component
export const TemplateDetailProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [slug, setSlug] = useState<string | null>(null);
  const [useCase, setUseCase] = useState<string | null>(null);
  const [primaryProduct, setPrimaryProduct] = useState<string | null>(null);
  return (
    <TemplateDetailContext.Provider
      value={{
        isOpen,
        setIsOpen,
        slug,
        setSlug,
        useCase,
        setUseCase,
        primaryProduct,
        setPrimaryProduct,
      }}
    >
      {children}
    </TemplateDetailContext.Provider>
  );
};

// Create a custom hook to use the context
export const useTemplateDetail = (): TemplateDetailContextType => {
  const context = useContext(TemplateDetailContext);
  return context;
};
